var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg230Dn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55,
    height: 53,
    viewBox: "0 0 55 53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -2)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009EFF",
    d: "M21.38,45.229 C20.057,47.783 17.038,46.112 18.308,43.647 C19.386,41.552 21.976,40.285 21.976,40.285 C21.976,40.285 22.426,43.201 21.38,45.229 M39.83,45.229 C38.507,47.783 35.488,46.112 36.758,43.647 C37.836,41.552 40.426,40.285 40.426,40.285 C40.426,40.285 40.876,43.201 39.83,45.229"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FF7800",
    points: "32.372 43.465 29.556 43.422 31.865 39.385 28.302 39.413 25.278 45.438 27.91 45.438 24.215 54.566 32.372 43.465"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    opacity: 0.4,
    transform: "translate(0 -2)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#C9C9C9",
    strokeWidth: 1.4,
    d: "M6.06 29.503L45.192 29.503M11.689 39.708L50.821 39.708M4.561 24.401L43.519 24.401M9.762 34.606L48.72 34.606M6.06 9.093L45.192 9.093M11.689 19.298L50.821 19.298M4.561 3.99L43.519 3.99M10.29 14.16L49.248 14.16M4.561 45.097L43.519 45.097"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg230Dn);
export default __webpack_public_path__ + "static/media/230dn.c65d87337ab441c5ee38a2668b6766c7.svg";
export { ForwardRef as ReactComponent };